import { SOCKET_RECONNECT_CONFIG } from "../lib/socket";

export const CONNECTION_STATES = Object.freeze({
  CONNECTED: "connected",
  RECONNECTING: "reconnecting",
  OFFLINE: "offline",
});

export const MAX_RECONNECT_ATTEMPTS =
  SOCKET_RECONNECT_CONFIG.reconnectionAttempts;

export const getDisconnectTelemetryDecision = () =>
  Object.freeze({
    addBreadcrumb: true,
    captureWarning: false,
    captureException: false,
  });

export const getConnectErrorTelemetryDecision = ({ hasCapturedInCycle }) =>
  Object.freeze({
    addBreadcrumb: hasCapturedInCycle,
    captureException: !hasCapturedInCycle,
  });

export const getReconnectFailedTelemetryDecision = () =>
  Object.freeze({
    addBreadcrumb: true,
    captureException: true,
  });

export const resolveDisconnectState = ({ reason, isManagerActive }) => {
  const shouldAttemptManualReconnect = reason === "io server disconnect";
  const nextConnectionState =
    shouldAttemptManualReconnect || isManagerActive
      ? CONNECTION_STATES.RECONNECTING
      : CONNECTION_STATES.OFFLINE;

  return Object.freeze({
    nextConnectionState,
    shouldAttemptManualReconnect,
  });
};

export const normalizeReconnectAttempt = (attempt) => {
  const parsedAttempt = Number(attempt);
  if (Number.isInteger(parsedAttempt) && parsedAttempt > 0) {
    return parsedAttempt;
  }
  return 1;
};
